/* ===================================================================
   Kkumi collection — AJAX filtering, custom price slider, sort,
   and mobile rail. All wired via event delegation on a stable root
   so it survives the AJAX innerHTML swaps.
   =================================================================== */
(function () {
  'use strict';

  var ROOT_SEL = '.kkumi-collection';
  var CONTAINER_SEL = '.kkumi-collection__container';

  function root() { return document.querySelector(ROOT_SEL); }
  function container() { return document.querySelector(CONTAINER_SEL); }

  /* ---------- AJAX navigation ---------- */
  var inflight = null;

  function navigate(url, push) {
    var box = container();
    if (!box) { window.location.href = url; return; }
    box.classList.add('is-loading');
    if (inflight) inflight.abort && inflight.abort();
    var ctrl = (window.AbortController) ? new AbortController() : null;
    inflight = ctrl;
    fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector(CONTAINER_SEL);
        var cur = container();
        if (fresh && cur) { cur.innerHTML = fresh.innerHTML; }
        if (push !== false) {
          try { history.pushState({ kkurl: url }, '', url); } catch (e) {}
        }
        afterRender();
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.href = url;
      });
  }

  function afterRender() {
    var box = container();
    if (box) box.classList.remove('is-loading');
    initSliders();
    updateSticky();
    applyDesktopRail();
    // close the mobile rail after a selection
    closeRail();
    document.dispatchEvent(new CustomEvent('kkumi:collection:updated'));
  }

  window.addEventListener('popstate', function () {
    navigate(window.location.href, false);
  });

  /* ---------- Desktop rail toggle ---------- */
  // From 1090px (matches the CSS) the rail sits inline beside the grid but is
  // hidden until the toolbar's Filters button opens it: .is-rail-open on the
  // listing shows it and takes a grid column away. The choice is remembered
  // for the tab (sessionStorage) and re-applied after every AJAX swap, so
  // picking a filter doesn't snap the rail shut.
  var DESKTOP = '(min-width: 1090px)';
  var RAIL_KEY = 'kk-rail-open';
  var desktopRailOpen = false;
  try { desktopRailOpen = sessionStorage.getItem(RAIL_KEY) === '1'; } catch (e) {}
  function applyDesktopRail() {
    var listing = document.querySelector('.kkumi-collection .kkumi-listing');
    if (listing) listing.classList.toggle('is-rail-open', desktopRailOpen);
    var btn = document.getElementById('kkumi-filter-toggle');
    if (btn) {
      btn.setAttribute('aria-controls', 'main-collection-filters');
      btn.setAttribute('aria-expanded', window.matchMedia(DESKTOP).matches && desktopRailOpen ? 'true' : 'false');
    }
  }
  function toggleDesktopRail() {
    desktopRailOpen = !desktopRailOpen;
    try { sessionStorage.setItem(RAIL_KEY, desktopRailOpen ? '1' : '0'); } catch (e) {}
    applyDesktopRail();
  }
  var desktopMq = window.matchMedia(DESKTOP);
  if (desktopMq.addEventListener) desktopMq.addEventListener('change', applyDesktopRail);
  document.addEventListener('shopify:section:load', applyDesktopRail);

  /* ---------- Mobile rail open / close ---------- */
  function openRail() {
    // Drawer mode is mobile/tablet only (≤1089px, matches the CSS). On desktop
    // the rail is inline (toggled above), so opening the drawer here would
    // just lock body scroll with no close affordance.
    if (desktopMq.matches) return;
    var rail = document.getElementById('main-collection-filters');
    var overlay = document.getElementById('kkumi-rail-overlay');
    if (rail) rail.classList.add('is-open');
    if (overlay) overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }
  function closeRail() {
    var rail = document.getElementById('main-collection-filters');
    var overlay = document.getElementById('kkumi-rail-overlay');
    if (rail) { rail.classList.remove('is-open'); rail.style.transform = ''; rail.style.transition = ''; }
    if (overlay) overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  /* Swipe-to-dismiss the mobile rail. Bound to document so it survives the
     AJAX container re-renders. */
  (function () {
    var y0, yPrev, dy, vy, active, rail;
    document.addEventListener('touchstart', function (e) {
      rail = e.target.closest && e.target.closest('#main-collection-filters');
      if (!rail || !rail.classList.contains('is-open') || rail.scrollTop > 2) { active = false; return; }
      y0 = yPrev = e.touches[0].clientY; dy = 0; vy = 0; active = true;
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      if (!active || !rail) return;
      var y = e.touches[0].clientY;
      vy = y - yPrev; yPrev = y; dy = Math.max(0, y - y0);
      var visual = dy < 80 ? dy : 80 + Math.sqrt(dy - 80) * 8;
      rail.style.cssText += '; transform: translateY(' + visual + 'px) !important; transition: none !important;';
    }, { passive: true });
    document.addEventListener('touchend', function () {
      if (!active || !rail) return;
      active = false;
      if (vy > 2 || dy > 100) {
        rail.style.cssText += '; transform: translateY(110vh) !important; transition: transform 0.35s cubic-bezier(.4,.9,.3,1) !important;';
        setTimeout(closeRail, 380);
      } else {
        rail.style.cssText += '; transform: translateY(0) !important; transition: transform 0.5s cubic-bezier(.175,.885,.32,1.275) !important;';
      }
    }, { passive: true });
  }());

  /* ---------- Sort dropdown ---------- */
  function closeSort() {
    var g = document.getElementById('kkumi-sort-group');
    if (g) {
      g.classList.remove('is-open');
      var t = g.querySelector('.kkumi-sort-btn');
      if (t) t.setAttribute('aria-expanded', 'false');
    }
  }
  function openSort() {
    var g = document.getElementById('kkumi-sort-group');
    if (g) {
      g.classList.add('is-open');
      var t = g.querySelector('.kkumi-sort-btn');
      if (t) t.setAttribute('aria-expanded', 'true');
    }
  }
  function applySort(value) {
    var params = new URLSearchParams(window.location.search);
    params.set('sort_by', value);
    params.delete('page');
    navigate(window.location.pathname + '?' + params.toString());
  }

  /* ---------- Sticky bar label ---------- */
  function updateSticky() {
    var bar = document.getElementById('kkumi-sticky-filter');
    if (!bar) return;
    var count = document.querySelector('.kkumi-toolbar__count');
    var lbl = bar.querySelector('.lbl');
    if (count && lbl) {
      var main = lbl.childNodes[0];
      if (main) main.nodeValue = count.textContent.trim() + ' ';
    }
  }

  /* ---------- Delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    if (!root()) return;

    // Rail toggles: the toolbar button shows / hides the inline rail on
    // desktop and opens the drawer below 1090px; the sticky bar is drawer-only.
    if (e.target.closest('#kkumi-filter-toggle') && desktopMq.matches) {
      e.preventDefault(); toggleDesktopRail(); return;
    }
    if (e.target.closest('#kkumi-filter-toggle, #kkumi-sticky-filters')) {
      e.preventDefault(); openRail(); return;
    }
    if (e.target.closest('#kkumi-rail-close, #kkumi-rail-overlay')) {
      e.preventDefault(); closeRail(); return;
    }
    // Sticky "Sort" opens the dropdown
    if (e.target.closest('#kkumi-sticky-sort')) {
      e.preventDefault();
      openSort();
      var g = document.getElementById('kkumi-sort-group');
      if (g) g.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    // Sort dropdown
    var sortBtn = e.target.closest('.kkumi-sort-btn');
    if (sortBtn) {
      e.preventDefault(); e.stopPropagation();
      var grp = document.getElementById('kkumi-sort-group');
      if (grp && grp.classList.contains('is-open')) { closeSort(); } else { openSort(); }
      return;
    }
    var sortLi = e.target.closest('.kkumi-toolbar__sort-list li');
    if (sortLi) {
      e.preventDefault();
      closeSort();
      if (sortLi.dataset.value) applySort(sortLi.dataset.value);
      return;
    }

    // Filter links (rail options, clear-all, applied pills) → AJAX
    var link = e.target.closest(
      '.kkumi-collection .rail .blk a, .kkumi-collection .rail-top a.clear, .kkumi-collection [data-kkumi-facet-remove]'
    );
    if (link && link.getAttribute('href')) {
      // ignore the size-guide helper button (real navigation)
      if (link.closest('.rail-helper')) return;
      e.preventDefault();
      // Optimistically flip the check/swatch state so the rail responds
      // instantly instead of appearing to hang until the AJAX call returns.
      var li = link.closest('.blk li');
      if (li) { li.classList.toggle('on'); }
      else if (link.classList.contains('sw')) { link.classList.toggle('on'); }
      navigate(link.href);
      return;
    }

    // Click outside the sort group closes it
    if (!e.target.closest('#kkumi-sort-group')) closeSort();
  }, false);

  /* ---------- Custom dual price slider ---------- */
  function initSliders() {
    document.querySelectorAll('[data-kk-price]').forEach(function (el) {
      if (el.__kkInit) return;
      el.__kkInit = true;

      var bar = el.querySelector('.price-bar');
      var fill = el.querySelector('.fill');
      var hMin = el.querySelector('[data-kk-price-handle="min"]');
      var hMax = el.querySelector('[data-kk-price-handle="max"]');
      var outMin = el.querySelector('[data-kk-price-out="min"]');
      var outMax = el.querySelector('[data-kk-price-out="max"]');
      if (!bar || !hMin || !hMax) return;

      var floor = parseInt(el.dataset.floor, 10) || 0;
      var ceil = parseInt(el.dataset.ceil, 10) || 0;
      var minName = el.dataset.minName;
      var maxName = el.dataset.maxName;
      var sym = (outMin && outMin.textContent.replace(/[\d.,\s]/g, '')) || '$';
      if (ceil <= floor) return;

      var curMin = clamp(parseInt(el.dataset.min, 10) || floor, floor, ceil);
      var curMax = clamp(parseInt(el.dataset.max, 10) || ceil, floor, ceil);

      function pct(v) { return ((v - floor) / (ceil - floor)) * 100; }
      function paint() {
        hMin.style.left = pct(curMin) + '%';
        hMax.style.left = pct(curMax) + '%';
        bar.style.setProperty('--sl', pct(curMin) + '%');
        bar.style.setProperty('--sh', pct(curMax) + '%');
        if (outMin) outMin.textContent = sym + curMin;
        if (outMax) outMax.textContent = sym + curMax;
        hMin.setAttribute('aria-valuenow', curMin);
        hMax.setAttribute('aria-valuenow', curMax);
      }
      paint();

      function valueFromEvent(clientX) {
        var rect = bar.getBoundingClientRect();
        var ratio = (clientX - rect.left) / rect.width;
        ratio = Math.max(0, Math.min(1, ratio));
        return Math.round(floor + ratio * (ceil - floor)); // $1 steps
      }

      function commit() {
        var params = new URLSearchParams(window.location.search);
        params.delete('page');
        if (curMin > floor) { params.set(minName, curMin); } else { params.delete(minName); }
        if (curMax < ceil) { params.set(maxName, curMax); } else { params.delete(maxName); }
        navigate(window.location.pathname + '?' + params.toString());
      }

      function startDrag(handle, which) {
        return function (ev) {
          ev.preventDefault();
          handle.setPointerCapture && handle.setPointerCapture(ev.pointerId);
          function move(mv) {
            var v = valueFromEvent(mv.clientX);
            if (which === 'min') { curMin = clamp(v, floor, curMax); }
            else { curMax = clamp(v, curMin, ceil); }
            paint();
          }
          function up() {
            document.removeEventListener('pointermove', move);
            document.removeEventListener('pointerup', up);
            commit();
          }
          document.addEventListener('pointermove', move);
          document.addEventListener('pointerup', up);
        };
      }
      hMin.addEventListener('pointerdown', startDrag(hMin, 'min'));
      hMax.addEventListener('pointerdown', startDrag(hMax, 'max'));

      // Keyboard support
      hMin.addEventListener('keydown', keyHandler('min'));
      hMax.addEventListener('keydown', keyHandler('max'));
      function keyHandler(which) {
        return function (ev) {
          var step = (ev.key === 'ArrowLeft' || ev.key === 'ArrowDown') ? -1
                   : (ev.key === 'ArrowRight' || ev.key === 'ArrowUp') ? 1 : 0;
          if (!step) return;
          ev.preventDefault();
          if (which === 'min') curMin = clamp(curMin + step, floor, curMax);
          else curMax = clamp(curMax + step, curMin, ceil);
          paint(); commit();
        };
      }
    });
  }

  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

  /* ---------- Header height → CSS var ---------- */
  // The sticky-header component writes --header-height, but only when that
  // feature is on. We measure it ourselves so the rail's sticky top always
  // clears the nav regardless of sticky-header settings.
  function syncHeaderHeight() {
    var hdr = document.querySelector('.kkncl') || document.querySelector('.section-header');
    if (hdr) {
      document.documentElement.style.setProperty('--header-height', hdr.offsetHeight + 'px');
    }
  }
  window.addEventListener('resize', syncHeaderHeight, { passive: true });

  /* ---------- Boot ---------- */
  function boot() {
    if (!root()) return;
    syncHeaderHeight();
    initSliders();
    updateSticky();
    applyDesktopRail();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
}());
